import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/DeviceArchiveStatus.css';
import TableMap from './TableMap';
import CustomTitle from '../CustomElements/CustomTitle';
import ConfirmationPage from '../CustomElements/ConfirmationPage';
import CustomButton from '../CustomElements/CustomButton';
import Modal from '../Modal/Modal';
// Кастомные хуки
import { useRole } from '../../customHook/useRole';
// Действия Redux
import { initStatusesFromServer } from '../../redux/actions/statuses.action';
import { STATUS } from '../../constants/status';

// компонент для отображения таблицы статусов Архив устройства
// и обработки действий с ними.
// statusId = 12 - это статус Архив,

function DeviceArchiveStatus({ currentDevice, setActiveButton, activeButton, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  //проверяем роли пользователя
  const isMaster = useRole('master');

  //получаем массив статусов Хранение из стора
  const { archiveStatuses } = useSelector((state) => state?.statuses);

  // Получаем id статуса текущего устройства
  const deviceStatusId = currentDevice?.statusId;
  // Кнопка отключена, если статус не "Архив" (ARCHIVE = 12)
  const disabledBtn = deviceStatusId !== STATUS.ARCHIVE;

  // Состояние, указывающее открыто ли модальное окно
  const [isOpen, setIsOpen] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState({
    value: 'Все действия',
    label: t?.placeholderAllActions || 'Все действия',
  });
  const [selectedDateSort, setSelectedDateSort] = useState({
    value: 'Сначала новые',
    label: t?.placeholderDateSortNew || 'Сначала новые',
  });

  const handleButtonClick = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const handlerSubmit = () => {
    closeModal();
  };

  // Инициализации статусов с сервера. принимает id устройства и тип статусов
  useEffect(() => {
    dispatch(initStatusesFromServer(currentDevice.id, 'archive', selectedStatus, selectedDateSort));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus, selectedDateSort]);

  return (
    <>
      {/* Таблица со статусами */}
      {archiveStatuses && (
        <TableMap
          isBtn={false}
          data={archiveStatuses}
          handleButtonClick={handleButtonClick}
          currentDevice={currentDevice}
          setActiveButton={setActiveButton}
          activeButton={activeButton}
          archive={true}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          selectedDateSort={selectedDateSort}
          setSelectedDateSort={setSelectedDateSort}
          t={t}
        />
      )}
      {/* Блок с кнопками */}
      {!isMaster && (
        <div className="device-repair-status_button-container">
          <CustomButton
            className="device-repair-status_button"
            text={t?.confirmReturnButton || 'Вернуть на хранение'}
            colorText="#FFFFF"
            onClick={handleButtonClick}
            // disabled={disabledBtn}
            disabled={true}
          />
        </div>
      )}
      <Modal isOpen={isOpen} onClose={closeModal} containerSelector={'.table-for-devices_or_uipps_container'}>
        <CustomTitle
          titleText={t?.changeDataTitle || 'ИЗМЕНЕНИЕ ДАННЫХ'}
          deviceType={currentDevice.type}
          deviceId={currentDevice.id}
        />
        <ConfirmationPage
          confirmText={t?.confirmReturnText || 'Вы уверены, что хотите вернуть УИППС на хранение?'}
          confirmButtonText={t?.confirmReturnButton || 'Вернуть на хранение'}
          cancelButtonText={t?.cancelButton || 'Отменить'}
          onConfirm={handlerSubmit} // Функция, которая должна быть вызвана при подтверждении
          onCancel={closeModal} // Функция для закрытия модального окна или отмены действия
        />
      </Modal>
    </>
  );
}

export default DeviceArchiveStatus;
